var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M287.935 512H192V256h-64v-88.225l64-.029-.104-51.976C191.896 43.794 211.413 0 296.195 0h70.588v88.242h-44.115c-33.016 0-34.603 12.328-34.603 35.342l-.131 44.162h79.345l-9.352 88.225L288 256l-.065 256z"}));
}

Facebook.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Facebook;

Facebook.default = Facebook;
